import { PrivateNotesDraft } from "../../../../models/new/drafts/private-notes-draft.model";
import { Action } from "../../../action";

export enum PrivateNotesDraftActionTypes {
  INDEX_REQUEST = "[Private Notes Drafts NEW] Index Request",
  INDEX_SUCCESS = "[Private Notes Drafts NEW] Index Success",

  CREATE_REQUEST = "[Private Notes Drafts NEW] Create Request",
  CREATE_SUCCESS = "[Private Notes Drafts NEW] Create Success",

  SHOW_REQUEST = "[Private Notes Drafts NEW] Show Request",
  SHOW_SUCCESS = "[Private Notes Drafts NEW] Show Success",

  UPDATE_REQUEST = "[Private Notes Drafts NEW] Update Request",
  UPDATE_SUCCESS = "[Private Notes Drafts NEW] Update Success",

  DELETE_REQUEST = "[Private Notes Drafts NEW] Delete Request",
  DELETE_SUCCESS = "[Private Notes Drafts NEW] Delete Succes",
}

export class PrivateNotesDraftIndexRequest implements Action {
  readonly type = PrivateNotesDraftActionTypes.INDEX_REQUEST;
}

export class PrivateNotesDraftIndexSuccess implements Action {
  readonly type = PrivateNotesDraftActionTypes.INDEX_SUCCESS;

  constructor(public payload: PrivateNotesDraft[]) {
  }
}

export class PrivateNotesDraftCreateRequest implements Action {
  readonly type = PrivateNotesDraftActionTypes.CREATE_REQUEST;
}

export class PrivateNotesDraftCreateSuccess implements Action {
  readonly type = PrivateNotesDraftActionTypes.CREATE_SUCCESS;

  constructor(public payload: PrivateNotesDraft) {
  }
}

export class PrivateNotesDraftShowRequest implements Action {
  readonly type = PrivateNotesDraftActionTypes.SHOW_REQUEST;

  constructor(public payload: number) {

  }
}

export class PrivateNotesDraftShowSuccess implements Action {
  readonly type = PrivateNotesDraftActionTypes.SHOW_SUCCESS;

  constructor(public payload: PrivateNotesDraft) {
  }
}

export class PrivateNotesDraftUpdateRequest implements Action {
  readonly type = PrivateNotesDraftActionTypes.UPDATE_REQUEST;

  constructor(public payload: number) {
  }
}

export class PrivateNotesDraftUpdateSuccess implements Action {
  readonly type = PrivateNotesDraftActionTypes.UPDATE_SUCCESS;

  constructor(public payload: PrivateNotesDraft) {
  }
}

export class PrivateNotesDraftDeleteRequest implements Action {
  readonly type = PrivateNotesDraftActionTypes.DELETE_REQUEST;

  constructor(public payload: number) {
  }
}

export class PrivateNotesDraftDeleteSuccess implements Action {
  readonly type = PrivateNotesDraftActionTypes.DELETE_SUCCESS;

  constructor(public payload: number) {
  }
}
